
<button
    type="button"
    class="SiteButton"
    :class="[sizeClass, variantClass, { 'is-disabled': disabled }]"
    @click="$emit('onClick')"
>
    <span><slot></slot></span>
</button>
